<div class="bubble">
  <span>{{initials()}}</span>
</div>